import { useCallback, useContext, useMemo } from 'react';
import type { PopupState as PopupStateProps } from 'material-ui-popup-state/hooks';
import { MoreHorizontalAnchor } from '@/components/presentation/Anchor';
import { FolderActionsContextMenuPopper } from '@/components/Workspace.Folder/Folder.Actions.ContextMenu';
import type { FolderMenuItemsContextValue } from '@/containers/Workspace.Folder/Context';
import { FolderMenuItemsContext, FolderStateContext } from '@/containers/Workspace.Folder/Context';
import { FolderActionsContainer } from '@/containers/Workspace.Folder/FolderMenuContainer';
import styles from '@/screens/Workspace.File/style/Header.Actions.module.css';

export const FolderContextMenu = () => {

  const { capabilities, object, folder } = useContext(FolderStateContext);

  const menu: FolderMenuItemsContextValue = useMemo(() => ({
    canChangeOwner: capabilities.canChangeOwner,
    canDelete: capabilities.canDelete,
    canManageAccess: capabilities.canManageAccess,
    canMove: capabilities.canMove,
    canRename: capabilities.canRename,
    canAddChildren: capabilities.canAddChildren,
  }), [
    capabilities,
  ]);

  const renderAnchor = useCallback((state: PopupStateProps) => {
    return (
      <MoreHorizontalAnchor className={styles.menu} open={state.isOpen} />
    );
  }, []);

  return (
    <FolderMenuItemsContext.Provider value={menu}>
      <FolderActionsContainer
        folder={folder}
        object={object}>
        <FolderActionsContextMenuPopper renderAnchor={renderAnchor} />
      </FolderActionsContainer>
    </FolderMenuItemsContext.Provider>
  );
};